import './EventsBlock.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {Autoplay, Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {Link} from "react-router-dom";
import React from "react";
import moment from "moment";


function EventBlock (props){
    const {event,staticTexts} = props

    return <div className={'eventBlock-wrapper'}>
        {
            event?.length ? <div className={'eventBlock-header'}>
                <div className={'eventBlock-title'}>
                    {staticTexts?.homepage_events_title}
                </div>
                <Link to={'/event'} className={'eventBlock-more'}>
                    {staticTexts?.homepage_events_more}
                </Link>
            </div> : ''
        }
        <div className={'eventsBlock-items'}>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                loop={true}
                style={{
                    '--swiper-navigation-color': '#fff',
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={event?.length > 1 ? true : false}
                modules={[Autoplay, Navigation]}
                className="mySwiper"
            >
                {
                    event?.map(item => {
                        return <SwiperSlide>
                            <Link to={`/news/${item?.slug}`} className={'eventBlock-item-wrapper'}>
                                <div className={'eventBlock-item-type'}>
                                    {item?.type}
                                </div>
                                <div className={'eventBlock-item-img'}>
                                    <img src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.lightPath || item?.mediaMain?.path)} alt=""/>
                                </div>
                                <div className={'eventBlock-item-info'}>
                                    <div className={'eventBlock-item-date'}>
                                        {moment(item?.date).format('ll')}
                                    </div>
                                    <div className={'eventBlock-item-title'}>
                                        <span>{item?.title}</span>
                                    </div>
                                    <div className={'eventBlock-item-description'}
                                         // dangerouslySetInnerHTML={{__html: item?.description}}
                                    >
                                        {item?.subTitle}
                                    </div>
                                </div>
                                <div className={'eventBlock-gradient'}/>
                            </Link>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'requestLoading',
        'event',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(EventBlock);
